import { render, staticRenderFns } from "./DeviceOptions.vue?vue&type=template&id=65c32186&scoped=true"
import script from "./DeviceOptions.vue?vue&type=script&lang=ts"
export * from "./DeviceOptions.vue?vue&type=script&lang=ts"
import style0 from "./DeviceOptions.vue?vue&type=style&index=0&id=65c32186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c32186",
  null
  
)

export default component.exports